import axios from "axios"
import accessToken from "./jwt-token-access/accessToken"
import store from '../store'
import { logoutUser } from "../store/actions"
import Cookies from 'js-cookie'
//pass new generated access token here


//apply base url for axios
const API_URL = process.env.REACT_APP_BASE_API
const NODE_ADMIN = process.env.REACT_APP_NODE_ADMIN
const NODE_ADMIN_LYSTLOC = process.env.REACT_APP_NODE_LYSTLOC

const axiosNodeLystlocApi = axios.create({
  baseURL: NODE_ADMIN_LYSTLOC,
})

const axiosNodeAdminApi = axios.create({
  baseURL: NODE_ADMIN,
})

export const axiosApi = axios.create({
  baseURL: API_URL,
})
axiosApi.defaults.withCredentials = true

export const setupInterceptors = (navigate) => {
  axiosApi.interceptors.response.use(
    async response => {
      if (response?.data?.response?.expired) {
        store.dispatch(logoutUser({ history: navigate, timeout: true }));
      }
      return response

    },
    async error => {
      return Promise.reject(error);
    }

  )
}

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, data, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}

export async function getNodeAdminAPI(url, config = {}) {
  return await axiosNodeAdminApi.get(url, { ...config }).then(response => response.data)
}
export async function getNodeLystlocAPI(url, config = {}) {
  return await axiosNodeLystlocApi.get(url, { ...config }).then(response => response.data)
}
